import { Snackbar } from "@material-ui/core";

import { useState } from "react";

import { Alert } from "@material-ui/lab";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";

import { useNavigate } from "react-router-dom";
import RateService from "../../services/RateService";

const AddRate = () => {
  const navigate = useNavigate();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [name, setName] = useState();
  const [value, setValue] = useState();

  const [code, setCode] = useState();

  const [desc, setDesc] = useState();

  const [type, setType] = useState(1);
  const [typeTVA, setTypeTVA] = useState(2);

  const [typeTax, setTypeTax] = useState(1);

  const onChangeNameHandler = (event) => {
    setName(event.target.value);
  };
  const onChangeValueHandler = (event) => {
    setValue(event.target.value);
  };
  const onChangeCodeHandler = (event) => {
    setCode(event.target.value);
  };

  const onChangeDescriptionHandler = (event) => {
    setDesc(event.target.value);
  };

  const onValidTaxHandler = () => {
    console.log(value);
    if (name == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Libellé est vide ! ");
    } else if (code === null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Code est vide ! ");
    } else if (
      (typeTax === "1" || typeTax === 1) &&
      (value === null || value === undefined)
    ) {
      setOpenErrorAlert(true);
      setErrorAlertText("Valeur est vide ! ");
    } else if (desc === null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Description est vide ! ");
    } else {
      let rateModel = {
        name: name,
        description: desc,
        idUserCreation: getCurrentUserId(),
        type: type,
        code: code,
        value: value,
        typeTax: typeTax,
        typeTVA: typeTVA,
      };
      console.log("rateModel", rateModel);

      RateService.addNewRate(rateModel).then((result) => {
        console.log("result", result.data["success"]);
        if (result.data["success"]) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/taxes`);
          }, 2000);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :erreur serveur ");
        }
      });
    }
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const labelStyle = {
    fontSize: "0.8rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    color: "#6c757d",
  };

  const segmented = (options, current, onSelect) => (
    <div
      role="group"
      style={{
        display: "inline-flex",
        padding: 3,
        borderRadius: 8,
        backgroundColor: "#f1f3f5",
        border: "1px solid #e9ecef",
      }}
    >
      {options.map((o) => {
        const active = current === o.value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onSelect(o.value)}
            style={{
              border: "none",
              borderRadius: 6,
              padding: "5px 16px",
              fontSize: "0.9rem",
              fontWeight: active ? 600 : 400,
              color: active ? "#fff" : "#495057",
              backgroundColor: active ? "#343a40" : "transparent",
              boxShadow: active ? "0 1px 3px rgba(0,0,0,.2)" : "none",
              cursor: "pointer",
              transition: "background-color .15s, color .15s",
            }}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );

  const typeFacture = () => {
    if (typeTax === 2) {
      return (
        <div className="form-group">
          <label style={labelStyle}>Facturation</label>
          <div>
            {segmented(
              [
                { value: 1, label: "Avec facture" },
                { value: 2, label: "Sans facture" },
              ],
              type,
              setType
            )}
          </div>
        </div>
      );
    } else if (typeTax === 1) {
      return (
        <div className="form-group">
          <label style={labelStyle}>Application</label>
          <div>
            {segmented(
              [
                { value: 1, label: "Appliqué sur TTC" },
                { value: 2, label: "Appliqué sur HTC" },
              ],
              typeTVA,
              setTypeTVA
            )}
          </div>
        </div>
      );
    }
  };

  const required = <span style={{ color: "#dc3545" }}>*</span>;

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-percent mr-2"></i>Ajouter une taxe / charge
              </h4>
              <small className="text-muted">
                Créez une taxe ou une charge applicable à vos achats
              </small>
            </div>
            <button
              className="btn btn-outline-secondary mt-2 mt-sm-0"
              onClick={() => navigate("/taxes")}
            >
              <i className="fas fa-arrow-left mr-1"></i>
              Retour aux taxes
            </button>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row mt-3">
            <div className="col-12">
              <div
                className="card card-outline card-dark"
                style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
              >
                <div className="card-body">
                  <div className="d-flex flex-wrap">
                    <div className="form-group mr-5">
                      <label style={labelStyle}>Type</label>
                      <div>
                        {segmented(
                          [
                            { value: 1, label: "Taxe" },
                            { value: 2, label: "Charge" },
                          ],
                          typeTax,
                          setTypeTax
                        )}
                      </div>
                    </div>
                    {typeFacture()}
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="taxCode" style={labelStyle}>
                          Code {required}
                        </label>
                        <input
                          placeholder="Ajouter code"
                          onChange={onChangeCodeHandler}
                          type="text"
                          id="taxCode"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="taxName" style={labelStyle}>
                          Libellé {required}
                        </label>
                        <input
                          placeholder="Ajouter libellé"
                          onChange={onChangeNameHandler}
                          type="text"
                          id="taxName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    {typeTax === 1 && (
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="taxValue" style={labelStyle}>
                            Valeur {required}
                          </label>
                          <div className="input-group">
                            <input
                              placeholder="Ex : 19"
                              onChange={onChangeValueHandler}
                              type="text"
                              id="taxValue"
                              className="form-control"
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">%</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="form-group mb-0">
                    <label htmlFor="inputDescription" style={labelStyle}>
                      Description {required}
                    </label>
                    <textarea
                      placeholder="Saisir..."
                      onChange={onChangeDescriptionHandler}
                      id="inputDescription"
                      className="form-control"
                      rows={3}
                      defaultValue={""}
                    />
                  </div>
                </div>
                <div className="card-footer d-flex justify-content-end">
                  <button
                    className="btn btn-outline-secondary mr-2"
                    onClick={() => navigate("/taxes")}
                  >
                    Annuler
                  </button>
                  <button className="btn btn-dark" onClick={onValidTaxHandler}>
                    <i className="fas fa-check mr-1"></i>
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default AddRate;
